"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
/**
 * This scene handles removing any client-side auth data (local storage, axios interceptors, logged in state, etc),
 * and closing any preloaders that may have been left open, when an API call results in an HTTP 401.
 * This prevents the LoginScene from needing to handle this behavior, and prevents the login scene route from needing
 * to be accessible to a logged-in user
 *
 * @constructor
 */
const InactiveScene = () => {
    const { authStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('inactive');
        authStore.clearLoginData();
        navigate(navigation_1.default.login.inactive());
        preloaderStore.openMainPreloader(false);
        preloaderStore.openTransparentPreloader(false);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.login.inactive() }, "Go To Login Page")));
};
exports.default = InactiveScene;
